import React from "react";
import { ICommonPageContent, PLACEHOLDERS } from "app/api/types";

import TextArea from "app/components/Elements/TextArea";
import ImgUpload from "./components/ImgUpload";
import Field from "../Elements/Field";

import "./styles.scss";

interface IProps {
  content: ICommonPageContent | any; // потому что content[key] не хочет работать
  onDelete: ((id: string) => void) | null;
  handleChange: (e: any) => void;
  handleSubmit: () => void;
}

const ContentGroup: React.FC<IProps> = ({
  content,
  handleChange,
  handleSubmit,
  onDelete,
}) => {
  const renderField = (key: string) => {
    if (!content.hasOwnProperty(key)) return;

    switch (key) {
      case "src":
        return (
          <ImgUpload
            content={content}
            key={`${content.id}-img-upload`}
            name={`${content.id}--${key}`}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            readOnly
          />
        );
      case "text":
      case "description":
        return (
          <TextArea
            className="content-group__field"
            value={content[key]}
            key={`${content.id}-textarea`}
            placeholder={PLACEHOLDERS[key]}
            name={`${content.id}--${key}`}
            onChange={handleChange}
          />
        );
      case "name":
      case "price":
      case "href":
      case "status":
      case "shortDescription":
        return (
          <Field
            className="content-group__field"
            value={content[key]}
            key={`${content.id}-${key}-field`}
            placeholder={PLACEHOLDERS[key]}
            name={`${content.id}--${key}`}
            onChange={handleChange}
          />
        );
      default:
        return;
    }
  };

  return (
    <div className="content-group">
      {onDelete && (
        <p
          className="content-group__delete"
          onClick={() => onDelete(content.id)}
        >
          удалить
        </p>
      )}
      <p className="content-group__header">{content.title}</p>
      {Object.keys(content).map((key) => renderField(key))}
    </div>
  );
};

export default ContentGroup;
